export default __webpack_public_path__ + "static/media/footer.74003aa6.webp";